import Vue from 'vue'
import Vuex from 'vuex'
import mockData from './mockData'
Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    ...mockData,
    playing: null,
    playState: null,
    provider: "sa"
  },
  mutations: {
    PLAY_EPISODE (state, payload) {
      state.playing = payload
      state.playState = 'playing'
    },
    PAUSE_EPISODE (state) {
      state.playState = 'paused'
    },
    SET_PROVIDER(state, payload) {
      state.provider = payload
    }
  },
  actions: {
  },
  modules: {
  }
})
